import { Radio } from "antd";
import "./radio_comp.scss";
import TooltipComp from "../Tooltip";
import { InfoWarningIcon } from "themes/Icon";

function RadioComp({ data, onChange, selected, displayTooltip, disabled = false }) {
  const onRadioChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <Radio.Group
      className="radio-comp"
      onChange={onRadioChange}
      value={selected}
      disabled={disabled}
    >
      {data.map((item, index) => (
        <Radio key={index} value={item.value}>
          <span className="flex align-center gap-1">
            {item?.label}
            {displayTooltip && (
              <TooltipComp title={item?.tooltipContent}>
                <span>
                  <InfoWarningIcon />
                </span>
              </TooltipComp>
            )}
          </span>
        </Radio>
      ))}
    </Radio.Group>
  );
}

export default RadioComp;
